<template>
  <LinkWrapper :href="prerollTargetUrl" target="_blank" @click="handleClick">
    <img :src="prerollImage" class="preroll" alt="preroll image" />
  </LinkWrapper>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { injectPreroll } from "../hooks/usePreroll";
import { useAnalytics } from "../hooks/useAnalytics";
import * as generateLinks from "@fresh8/ad-data-composition/src/lib/generateLinks";
import { injectBetData } from "@fresh8/ad-data-composition/src/betData";
import LinkWrapper from "./LinkWrapper.vue";

export default defineComponent({
  name: "Preroll",
  props: {
    sizeId: {
      type: String,
      required: true
    }
  },
  components: { LinkWrapper },
  setup() {
    const betData = injectBetData();
    const { handleClick } = useAnalytics({}, "Pre-roll");
    const { prerollImage, prerollTargetUrl: prerollUrl } = injectPreroll();

    // use registration url as the default if no target is set on the brand or adtag.
    const prerollTargetUrl = computed(() => {
      let url = betData?.links.value?.registration;

      // Find pre-roll targetUrl if set on the brand.
      let targetUrl = prerollUrl.value;

      // use customTargetUrl set on the adtag if set.
      if (
        betData?.prerollTargetUrl.value &&
        betData?.prerollTargetUrl.value !== ""
      ) {
        targetUrl = betData?.prerollTargetUrl.value;
      }

      if (targetUrl !== undefined && targetUrl !== "") {
        url = generateLinks.cta(targetUrl, {
          affiliateId: betData?.affiliateId.value,
          clickUrl: betData?.clickUrl.value,
          operatorKey: betData.operator.value.name
        });
      }

      return url;
    });

    return {
      handleClick,
      prerollImage,
      prerollTargetUrl
    };
  }
});
</script>
